import {
  Typography,
} from "antd";

const { Title, Text } = Typography;

type StepPlaceholderProps = {
  step: number;
  label: React.ReactNode;
  onBack?: () => void;
  onNext: () => void;
  isLast?: boolean;
};

export default function StepPlaceholder({ step, label, onBack, onNext, isLast }: StepPlaceholderProps) {
  return (
    <div className="cs-steps-wrapper">
      <div className="cs-step-number">{step}</div>
      <Title level={4} className="m-0">
        {label}
      </Title>
      <Text type="secondary">Configure step {step} of 5 here.</Text>
      <div className="d-flex gap-12 mtx-24 w-full justify-between">
        {onBack && (
          <button onClick={onBack} className="cs-launch-back-button">
            Back
          </button>
        )}
        {!isLast ? (
          <button onClick={onNext} className="cs-launch-next-button">
            Next
          </button>
        ) : (
          <button onClick={onNext} className="cs-launch-campaign-button">
            Launch Campaign
          </button>
        )}
      </div>
    </div>
  );
}